import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { BackgroundEffectGroups } from '../../../types';
import { BackgroundEffectsItem } from '..';
import './styles.scss';
import { useSelector } from 'react-redux';
import { selectIsInstitutionOwner } from '../../../../../store/features/system';
import { getIsLogoHorizontalDefault } from '../helpers';
export const BackgroundEffectsList = ({ effects, selectedEffect, onSelectEffect, }) => {
    const intl = useIntl();
    const isInstitutionOwner = useSelector(selectIsInstitutionOwner);
    const groupedEffects = useMemo(() => {
        const groups = [];
        for (const group in BackgroundEffectGroups) {
            const filteredEffects = effects
                .filter((effect) => effect.group === group)
                .sort((effect1, effect2) => effect1.index - effect2.index);
            groups.push({
                key: group,
                effects: filteredEffects,
            });
        }
        return groups;
    }, [effects]);
    const getEffectSpecificProps = (effect) => {
        switch (effect.name) {
            case 'Branded':
                const disabled = getIsLogoHorizontalDefault();
                const ownerTooltip = {
                    title: intl.formatMessage({
                        id: 'backgroundEffects.options.branded.disabled.title',
                    }),
                    description: intl.formatMessage({
                        id: 'backgroundEffects.options.branded.disabled.owner.description',
                    }),
                    linkText: intl.formatMessage({
                        id: 'backgroundEffects.options.branded.disabled.owner.linkText',
                    }),
                    linkHref: intl.formatMessage({
                        id: 'backgroundEffects.options.branded.disabled.owner.linkHref',
                    }),
                };
                const memberTooltip = {
                    title: intl.formatMessage({
                        id: 'backgroundEffects.options.branded.disabled.title',
                    }),
                    description: intl.formatMessage({
                        id: 'backgroundEffects.options.branded.disabled.member.description',
                    }),
                };
                const tooltip = disabled
                    ? isInstitutionOwner
                        ? ownerTooltip
                        : memberTooltip
                    : undefined;
                return {
                    disabled,
                    tooltip,
                };
            default:
                return null;
        }
    };
    return (<div className="background-effects" data-testid="background-effects__container">
      {groupedEffects.map((item) => (<div key={item.key}>
          <p>
            {intl.formatMessage({
                id: `backgroundEffects.category.${item.key}`,
                defaultMessage: 'Category',
            })}
          </p>
          <ul role="radiogroup" className="background-effects__list" aria-label={intl.formatMessage({
                id: item.key,
                defaultMessage: 'label',
            })}>
            {item.effects.map((effect) => (<BackgroundEffectsItem onSelect={() => onSelectEffect(effect)} selected={selectedEffect.name === effect.name} title={effect.metadata.title} label={effect.metadata.label} thumbnail={effect.metadata.thumbnail} icon={effect.metadata.icon} key={effect.name} index={effect.index} {...getEffectSpecificProps(effect)}/>))}
          </ul>
        </div>))}
    </div>);
};
